module.exports = "/fonts/tarra-h2h-picturemark-l-7f3e57254827a8c0392b3087552d0175.svg";